import {ACTION_RESET_PASSWORD_ERROR, ACTION_RESET_PASSWORD_LOADING, ACTION_RESET_PASSWORD_LOADED} from "../constants"

const reducer = (state = {
  loading: false,
  error: null,
  message: null
}, {type, payload}) => {
  if (type === ACTION_RESET_PASSWORD_LOADED) {
    return {
      loading: false,
      error: null,
      message: "Please check your email for new password."
    }
  }

  if (type === ACTION_RESET_PASSWORD_LOADING) {
    return {
      loading: true,
      error: null,
      message: null
    }
  }

  if (type === ACTION_RESET_PASSWORD_ERROR) {
    return {
      loading: false,
      error: op.get(payload, 'xhr.response', payload),
      message: null
    }
  }

  return state
}

export default reducer



// WEBPACK FOOTER //
// ./src/store/resetPasswordReducer.js